import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import { tlReadyExecute } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { AnalyticsAppThunk } from '@doda/common/src/types/analytics';
import { RootState } from 'redux/store';

/**
 * 類似キーワードがある際の求人の計測
 * @param existSimilarKeyword 類似キーワードの存在判定フラグ
 * @returns キーワードタグ求人閲覧AA計測
 */
export const measureSimilarKeywordJob =
  (existSimilarKeyword: boolean): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    if (existSimilarKeyword) {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_on_etsuran', {});
    } else {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_off_etsuran', {});
    }
  };

/**
 * 類似キーワードがある際の気になる押下時の計測
 * @param existSimilarKeyword 類似キーワードの存在判定フラグ
 * @returns キーワードタグ気になるクリックAA計測
 */
export const measureSimilarKeywordFavorite =
  (existSimilarKeyword: boolean): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    if (existSimilarKeyword) {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_on_favorite', {});
    } else {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_off_fovorite', {});
    }
  };

/**
 * 類似キーワードがある際の応募押下時の計測
 * @param existSimilarKeyword 類似キーワードの存在判定フラグ
 * @returns キーワードタグ応募クリックAA計測
 */
export const measureSimilarKeywordApplyJob =
  (existSimilarKeyword: boolean): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    if (existSimilarKeyword) {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_on_oubo', {});
    } else {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_off_oubo', {});
    }
  };
